import { create } from 'zustand';

const initialOwnerState = {
  id: null,
  name: "",
  address: "",
  region: null,
  phone: "",
  email: "",
  regional_id: "",
  fiscal_type: null,
  notes: "",
  image_url: null,
  thumb_url: null,
};

const useOwnerStore = create((set) => ({
  // Estado inicial
  owner: { ...initialOwnerState },

  // Acciones
  setOwner: (owner) => set({ owner }),

  // Acciones específicas
  updateOwner: (updates) => set((state) => ({
    owner: { ...state.owner, ...updates }
  })),

  // Resetear owner
  resetOwner: () => set({ owner: { ...initialOwnerState } })
}));

export default useOwnerStore;

